export const environment = {
  production: false,
  baseUrl: 'https://mytinyapi.mytinyerp.com/api/',
  ipUrl:'https://api.ipify.org/?format=json',
};